import { Injectable } from '@angular/core';
import { promise } from 'protractor';
import { Observable, forkJoin } from 'rxjs';
import { CourseService } from './course.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { Teacher } from '../models/teacher.model';
import { Setting } from '../models/setting.model';
import { Knowledge } from '../models/knowledge.model';
import { EnglishCourse } from '../models/english-course';
import { Partner } from '../models/partner.model';
import { SettingService } from './setting.service';
import { inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HomeService {


  constructor(
    private courseService: CourseService,
    private firestore: AngularFirestore,
    private settingService: SettingService
  ) { }

  getHomeData(): Observable<any> {
    const courses = this.courseService.findAll(3)
    const teachers = this.getTeachers(3)
    const knowledges = this.getKnowledges(15)
    const englishCourses = this.getEnlishCourses(15)
    const partners = this.getPartner(6)
    const homeData = forkJoin({
      courses: courses,
      teachers: teachers,
      knowledges: knowledges,
      englishCourses: englishCourses,
      partners: partners
    });
    return homeData
  }
  getTeachers(limit: number): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      this.firestore.collection('teachers', ref => ref.where('status', '==', 1).limit(limit)).get().subscribe(queriedItems => {
        var teachers = queriedItems.docs.map(function (doc) {
          var teacher: Teacher = new Teacher()
          const id = doc.id
          teacher.id = id
          Object.assign(teacher, doc.data())
          return teacher
        })
        resolve(teachers)
      })
    });
    return promise
  }

  getSetting(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      this.firestore.collection('setting').doc('YxGhCt3JiwGDQ8Gpeoj2').get().subscribe(queriedItem => {
        const setting = queriedItem.data() as Setting;
        this.settingService.set(setting);
        resolve(setting);
      })
    });
    return promise
  }
  getTranslate(): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      this.firestore.collection('translates').get().subscribe(queriedItems => {
        const translate = queriedItems.docs.reduce(function (acc, cur, i) {
          acc[cur.id] = cur.data();
          return acc;
        }, {});
        resolve(translate)
      })
    });
    return promise
  }

  getKnowledges(limit?: number): Promise<any> {
    let promise = new Promise((resolve, reject) => {
      var query: Observable<any>
      if (limit) {
        query = this.firestore.collection('knowledges', ref => ref.where('status', '==', 1).orderBy("createdAt", "desc").limit(limit)).get()
      } else {
        query = this.firestore.collection('knowledges', ref => ref.where('status', '==', 1).orderBy("createdAt", "desc")).get()
      }
      query.subscribe((queriedItems: any) => {
        var knowledges = queriedItems.docs.map(function (doc) {
          var knowledge: Knowledge = new Knowledge()
          const id = doc.id
          knowledge.id = id
          Object.assign(knowledge, doc.data())
          knowledge.mapping()
          return knowledge
        })
        resolve(knowledges)
      })
    });
    return promise
  }

  getKnowledgesPage(limit: number, cursor: any = null): Promise<any> {
    return new Promise((resolve, reject) => {
      const query: any = this.firestore.collection(
        'knowledges',
        ref => {
          let firestoreQuery: any = ref
            .where('status', '==', 1)
            .orderBy('updatedAt', 'desc');

          if (cursor) {
            firestoreQuery = firestoreQuery.startAfter(cursor);
          }

          return firestoreQuery.limit(limit + 1);
        }
      ).get();

      query.subscribe((queriedItems: any) => {
        let docs = queriedItems.docs;
        const hasNextPage = docs.length > limit;

        if (hasNextPage) {
          docs = docs.slice(0, limit);
        }

        const data = docs.map((doc: any) => {
          const knowledge: Knowledge = new Knowledge();
          knowledge.id = doc.id;
          Object.assign(knowledge, doc.data());
          knowledge.mapping();
          return knowledge;
        });

        resolve({
          data,
          lastDoc: docs.length ? docs[docs.length - 1] : null,
          hasNextPage
        });
      }, reject);
    });
  }

  getEnlishCourses(limit: number): Promise<EnglishCourse[]> {
    let promise: Promise<EnglishCourse[]> = new Promise((resolve, reject) => {
      this.firestore.collection('english-courses', ref => ref.where('status', '==', 1).limit(limit)).get().subscribe(queriedItems => {
        var courses = queriedItems.docs.map(function (doc) {
          var course: EnglishCourse = new EnglishCourse()
          course.id = doc.id
          Object.assign(course, doc.data())
          return course
        })
        resolve(courses)
      })
    });
    return promise
  }

  getPartner(limit?: number): Promise<Partner[]> {
    let promise: Promise<Partner[]> = new Promise((resolve, reject) => {
      var query: Observable<any>
      if (limit) {
        query = this.firestore.collection('partners', ref => ref.where('status', '==', 1).limit(limit)).get()
      } else {
        query = this.firestore.collection('partners', ref => ref.where('status', '==', 1)).get()
      }
      query.subscribe(queriedItems => {
        var partners = queriedItems.docs.map(function (doc) {
          var partner = doc.data() as Partner
          const id = doc.id
          partner.id = id
          return partner
        })
        resolve(partners)
      })
    });
    return promise
  }



}
